import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

// Function to safely access localStorage
const safeLocalStorage = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error("Error reading from localStorage:", error);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error("Error writing to localStorage:", error);
    }
  },
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error("Error removing from localStorage:", error);
    }
  },
};

export const useZodiacStore = create(
  persist(
    (set) => ({
      selectedZodiac: safeLocalStorage.getItem("selectedZodiac") || "",
      selectedRisingSign: "",
      setSelectedZodiac: (sign) =>
        set(() => ({
          selectedZodiac: sign,
        })),
      setSelectedRisingSign: (sign) => set({ selectedRisingSign: sign }),
    }),
    {
      name: "zodiac-storage", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage), // use localStorage
      partialize: (state) => ({ selectedZodiac: state.selectedZodiac }), // only persist the selectedZodiac field
      onRehydrateStorage: (state) => {
        console.log("Hydration finished for zodiac store");
        // optional: perform actions after hydration, like initializing state based on storage
        // We initialize directly in the create function now, so this might not be needed
        // return (state, error) => {
        //   if (error) {
        //     console.log('an error happened during hydration', error)
        //   } else {
        //     // state.hasHydrated = true // example: mark hydration as complete
        //   }
        // }
      },
    }
  )
);
